export const ADD_PRODUCT = 'productRequest/ADD_PRODUCT';
export const REMOVE_PRODUCT = 'productRequest/REMOVE_PRODUCT';
export const SEND_MESSAGE_REQUEST = 'productRequest/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'productRequest/SEND_MESSAGE_SUCCESS';
export const CLOSE_SUCCESS_MODAL = 'productRequest/CLOSE_SUCCESS_MODAL';
